<template>
    <div>
        <!-- V-Select general para búsqueda de pedidos -->
        <vx-card class="mb-4">
            <!-- Filtros de tipo de venta -->
            <div class="flex items-center justify-between mb-4 bg-gray-50 p-3 rounded">
                <h4 class="mr-4 font-bold">Filtros de Venta:</h4>
                <div class="flex items-center space-x-6">
                    <div class="flex items-center">
                        <vs-checkbox
                            v-model="filtroVentaDirecta"
                            color="success"
                            @input="aplicarFiltros"
                        >
                            <span class="font-semibold text-green-700">Venta Directa</span>
                        </vs-checkbox>
                    </div>
                    <div class="flex items-center">
                        <vs-checkbox
                            v-model="filtroVentaPorLista"
                            color="primary"
                            @input="aplicarFiltros"
                        >
                            <span class="font-semibold text-blue-700">Venta Por Lista</span>
                        </vs-checkbox>
                    </div>
                    <vs-chip
                        v-if="filtroVentaDirecta || filtroVentaPorLista"
                        :color="pedidosFiltrados.length !== allPedidos.length ? 'warning' : 'success'"
                        size="small"
                    >
                        {{ pedidosFiltrados.length }}/{{ allPedidos.length }} pedidos
                    </vs-chip>
                    <vs-chip
                        v-else
                        color="dark"
                        size="small"
                    >
                        Sin filtros - {{ allPedidos.length }} pedidos
                    </vs-chip>
                </div>
            </div>

            <div class="flex items-center mb-4">
                <h4 class="mr-4">Buscar Pedido:</h4>
                <div style="width: 90%">
                    <v-select
                        :options="pedidosFiltrados"
                        @input="seleccionarPedido"
                        :reduce="(pedido) => pedido"
                        label="nombreCompleto"
                        placeholder="Buscar por institución, pedido, asesor..."
                        :filterable="true"
                        v-model="pedidoSeleccionado"
                        class="w-full"
                    >
                        <template #option="option">
                            <div class="py-2">
                                <div class="flex justify-between items-start">
                                    <div class="flex-1">
                                        <div class="font-bold">{{ option.nombreInstitucion }}</div>
                                        <div class="text-sm text-gray-600">Pedido: {{ option.id_pedido }} | Asesor: {{ option.asesor }}</div>
                                        <div class="text-xs text-blue-600">{{ option.contrato_generado || 'Sin contrato' }}</div>
                                    </div>
                                    <div class="ml-2">
                                        <vs-chip
                                            :color="option.tipo_venta == 1 ? 'success' : 'primary'"
                                            size="small"
                                        >
                                            {{ option.tipo_venta == 1 ? 'Directa' : 'Por Lista' }}
                                        </vs-chip>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-select>
                </div>
                <!-- <vs-button v-if="pedidoSeleccionado" class="ml-3" color="success" @click="verPedidoSeleccionado">
                    Ver Pedido
                </vs-button> -->
            </div>
        </vx-card>

        <!-- Información del pedido seleccionado -->
        <vx-card v-if="pedidoSeleccionado" class="mt-4">
            <template slot="header">
                <div class="flex items-center justify-between">
                    <h3>Información de Venta - Pedido #{{ pedidoSeleccionado.id_pedido }}</h3>
                    <vs-button color="danger" size="small" @click="limpiarSeleccion">
                        <i class="fas fa-times"></i> Limpiar
                    </vs-button>
                </div>
            </template>

            <!-- Información básica del pedido -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div class="bg-gray-50 p-4 rounded">
                    <h4 class="font-bold text-primary">Institución</h4>
                    <p class="font-semibold">{{ pedidoSeleccionado.nombreInstitucion }}</p>
                    <p class="text-sm text-gray-600">{{ pedidoSeleccionado.nombre_ciudad }}</p>
                </div>
                <div class="bg-gray-50 p-4 rounded">
                    <h4 class="font-bold text-primary">Asesor</h4>
                    <p class="font-semibold">{{ pedidoSeleccionado.asesor }}</p>
                    <p class="text-sm text-gray-600">{{ pedidoSeleccionado.cedula_asesor }}</p>
                </div>
                <div class="bg-gray-50 p-4 rounded">
                    <h4 class="font-bold text-primary">Contrato</h4>
                    <p class="font-semibold">{{ pedidoSeleccionado.contrato_generado || 'Sin contrato' }}</p>
                    <p class="text-sm text-gray-600">Tipo: {{ pedidoSeleccionado.tipo_venta == 1 ? 'Directa' : 'Por Lista' }}</p>
                </div>
            </div>

            <!-- Botón de Proformar -->
            <!-- <div class="border-t pt-4 mb-4">
                <div class="text-center">
                    <vs-button color="success" type="gradient" size="large" @click="abrirProforma" class="px-8">
                        <i class="fas fa-file-invoice-dollar mr-2"></i>
                        Proformar
                    </vs-button>
                </div>
            </div> -->

            <!-- Botón de Generar Transacción con Perseo (se oculta en tab Obsequios) -->
            <div class="border-t pt-4 mb-4" v-show="tabActiva !== 2">
                <div class="text-center">
                    <vs-button color="success" type="gradient" size="large" @click="abrirVentasPerseo" class="px-8">
                        <i class="fas fa-cash-register mr-2"></i>
                        Generar Transacción
                    </vs-button>
                </div>
            </div>

            <!-- TABS: Listado General y Ventas -->
            <vs-tabs v-model="tabActiva" class="mt-4">
                <!-- TAB 1: Listado General -->
                <vs-tab label="Listado General" icon="list_alt">
                    <div class="pt-4">
                        <div class="flex justify-between items-center mb-4">
                            <div class="flex items-center gap-3">
                                <h4 class="font-bold">Libros del Pedido</h4>
                                <vs-button
                                    color="primary"
                                    type="flat"
                                    icon="refresh"
                                    title="Recargar"
                                    @click="recargarDatosTabla"
                                    :disabled="loadingLibros || loadingVendidos"
                                >
                                </vs-button>
                                <!-- Filtro Mostrar Pendientes -->
                                <vs-checkbox
                                    v-model="filtroPendientes"
                                    color="warning"
                                    class="ml-4"
                                >
                                    <span class="font-semibold text-orange-700">Mostrar solo Pendientes</span>
                                </vs-checkbox>
                            </div>
                            <div class="flex items-center gap-3">
                                <vs-chip v-if="librosPedido.length > 0" color="primary">
                                    Total: ${{ calcularTotalPedido() }}
                                </vs-chip>

                            </div>
                        </div>

                        <!-- RESUMEN TOTALES GENERALES (compacto) -->
                        <div v-if="librosParaTabla.length > 0" class="totales-barra mb-3">
                            <div class="totales-barra-inner">
                                <!-- CONTRATO -->
                                <div class="tb-seccion">
                                    <span class="tb-tag tb-tag-contrato">CONTRATO</span>
                                    <span class="tb-dato">Cant: <b>{{ totalesGenerales.contrato.cantidad }}</b></span>
                                    <span class="tb-dato">Subt: <b>${{ totalesGenerales.contrato.subtotal }}</b></span>
                                    <span class="tb-dato tb-dato-total">Total: <b>${{ totalesGenerales.contrato.total }}</b></span>
                                </div>
                                <div class="tb-divisor"></div>
                                <!-- VENTA -->
                                <div class="tb-seccion">
                                    <span class="tb-tag tb-tag-venta">VENTA</span>
                                    <span class="tb-dato">Cant: <b>{{ totalesGenerales.venta.cantidad }}</b></span>
                                    <span class="tb-dato">Subt: <b>${{ totalesGenerales.venta.subtotal }}</b></span>
                                    <span class="tb-dato tb-dato-total">Total: <b>${{ totalesGenerales.venta.total }}</b></span>
                                </div>
                                <div class="tb-divisor"></div>
                                <!-- PENDIENTE -->
                                <div class="tb-seccion">
                                    <span class="tb-tag tb-tag-pendiente">PENDIENTE</span>
                                    <span class="tb-dato">Cant: <b>{{ totalesGenerales.pendiente.cantidad }}</b></span>
                                    <span class="tb-dato">Subt: <b>${{ totalesGenerales.pendiente.subtotal }}</b></span>
                                    <span class="tb-dato tb-dato-total">Total: <b>${{ totalesGenerales.pendiente.total }}</b></span>
                                </div>
                            </div>
                        </div>

                        <!-- Loading de libros -->
                        <div v-if="loadingLibros" class="text-center py-12">
                            <div class="loading-spinner mb-4">
                                <div class="spinner"></div>
                            </div>
                            <p class="text-gray-600 text-lg">Cargando libros del pedido...</p>
                        </div>

                        <!-- Tabla de libros -->
                        <vs-table stripe v-else-if="librosPedido.length > 0" search :data="librosParaTabla" :max-items="librosParaTabla.length">
                    <template slot="header">
                        <vs-chip color="success">{{ librosParaTabla.length }} libros{{ filtroPendientes ? ' pendientes' : ' encontrados' }}</vs-chip>
                        <vs-chip v-if="filtroPendientes" color="warning" class="ml-2">Filtro: Pendientes</vs-chip>
                        <vs-button
                            v-if="librosParaTabla.length > 0"
                            color="success"
                            type="gradient"
                            icon="get_app"
                            @click="exportarExcel"
                            title="Exportar a Excel"
                            class="ml-2"
                        >
                            Exportar Excel
                        </vs-button>
                    </template>

                    <template slot="thead">
                        <vs-th sort-key="codigo">Código</vs-th>
                        <vs-th sort-key="nombre_libro">Libro</vs-th>
                        <vs-th sort-key="cantidad">
                            <div class="header-contrato">
                                <div class="contrato-label">CONTRATO</div>
                                <div>Cantidad</div>
                            </div>
                        </vs-th>
                        <vs-th sort-key="precio">
                            <div class="header-contrato">
                                <div class="contrato-label">CONTRATO</div>
                                <div>Precio Unit.</div>
                            </div>
                        </vs-th>
                        <vs-th sort-key="subtotal">
                            <div class="header-contrato">
                                <div class="contrato-label">CONTRATO</div>
                                <div>Subtotal</div>
                            </div>
                        </vs-th>
                        <vs-th sort-key="descuento">
                            <div class="header-contrato">
                                <div class="contrato-label">CONTRATO</div>
                                <div>Descuento</div>
                            </div>
                        </vs-th>
                        <vs-th sort-key="total">
                            <div class="header-contrato">
                                <div class="contrato-label">CONTRATO</div>
                                <div>Total</div>
                            </div>
                        </vs-th>
                        <!-- COLUMNAS DE PROFORMA - YA NO SE USA
                        <vs-th sort-key="cantidad_proformada">
                            <div class="header-proforma">
                                <div class="proforma-label">PROFORMA</div>
                                <div>Cantidad</div>
                            </div>
                        </vs-th>
                        <vs-th sort-key="descuento_proforma">
                            <div class="header-proforma">
                                <div class="proforma-label">PROFORMA</div>
                                <div>Descuento</div>
                            </div>
                        </vs-th>
                        <vs-th sort-key="subtotal_proformado">
                            <div class="header-proforma">
                                <div class="proforma-label">PROFORMA</div>
                                <div>Subtotal</div>
                            </div>
                        </vs-th>
                        <vs-th sort-key="total_proformado">
                            <div class="header-proforma">
                                <div class="proforma-label">PROFORMA</div>
                                <div>Total</div>
                            </div>
                        </vs-th>
                        -->
                        <!-- COLUMNAS DE VENTAS -->
                        <vs-th sort-key="cantidad_vendida">
                            <div class="header-venta">
                                <div class="venta-label">VENTA</div>
                                <div>Cantidad</div>
                            </div>
                        </vs-th>
                        <vs-th sort-key="descuento_venta">
                            <div class="header-venta">
                                <div class="venta-label">VENTA</div>
                                <div>Descuento</div>
                            </div>
                        </vs-th>
                        <vs-th sort-key="subtotal_vendido">
                            <div class="header-venta">
                                <div class="venta-label">VENTA</div>
                                <div>Subtotal</div>
                            </div>
                        </vs-th>
                        <vs-th sort-key="total_vendido">
                            <div class="header-venta">
                                <div class="venta-label">VENTA</div>
                                <div>Total</div>
                            </div>
                        </vs-th>
                        <!-- COLUMNA PENDIENTE A FACTURAR -->
                        <vs-th sort-key="pendiente_cantidad">
                            <div class="header-pendiente">
                                <div class="pendiente-label">PENDIENTE</div>
                                <div>Cantidad</div>
                            </div>
                        </vs-th>
                        <vs-th sort-key="pendiente_valor">
                            <div class="header-pendiente">
                                <div class="pendiente-label">PENDIENTE</div>
                                <div>Valor</div>
                            </div>
                        </vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :data="libro" :key="index" v-for="(libro, index) in data">
                            <vs-td>
                                <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                                    <!-- Badge para libros extras - ARRIBA -->
                                    <span v-if="libro.esLibroExtra" class="libro-extra-badge">
                                        <i class="fas fa-plus"></i> EXTRA
                                    </span>
                                    <!-- Código del libro - ABAJO -->
                                    <div class="font-mono text-sm font-bold text-primary">
                                        {{ libro.pro_codigo }}
                                    </div>
                                </div>
                            </vs-td>

                            <vs-td>
                                <div style="max-width: 300px;">
                                    <p class="font-semibold">{{ libro.nombre_libro }}</p>
                                </div>
                            </vs-td>

                            <!-- COLUMNAS DE CONTRATO -->
                            <vs-td>
                                <vs-chip color="dark" class="text-center">
                                    {{ libro.cantidad }}
                                </vs-chip>
                            </vs-td>

                            <vs-td>
                                <span class="font-semibold text-green-600">
                                    ${{ parseFloat(libro.precio).toFixed(2) }}
                                </span>
                            </vs-td>

                            <vs-td>
                                <span class="font-semibold text-blue-600">
                                    ${{ calcularSubtotalLibro(libro) }}
                                </span>
                            </vs-td>

                            <vs-td>
                                <vs-chip :color="libro.descuento > 0 ? 'warning' : 'dark'" size="small">
                                    {{ libro.descuento }}%
                                </vs-chip>
                            </vs-td>

                            <vs-td>
                                <span class="font-bold text-primary text-lg">
                                    ${{ calcularTotalLibro(libro) }}
                                </span>
                            </vs-td>

                            <!-- COLUMNAS DE PROFORMA - YA NO SE USA
                            <vs-td>
                                <div v-if="getDetallesProformaPorDescuento(libro.pro_codigo).length > 0">
                                    <div v-for="(detalle, idx) in getDetallesProformaPorDescuento(libro.pro_codigo)" :key="idx" class="detalle-row">
                                        <span class="cantidad-badge">{{ detalle.cantidad }}</span>
                                        <span v-if="getDetallesProformaPorDescuento(libro.pro_codigo).length > 1 && detalle.descuento > 0" class="descuento-badge-small">{{ detalle.descuento }}%</span>
                                    </div>
                                    <div v-if="getDetallesProformaPorDescuento(libro.pro_codigo).length > 1" class="total-row">
                                        <strong class="cantidad-total">{{ getDatosProforma(libro.pro_codigo).cantidadTotal }}</strong>
                                    </div>
                                </div>
                                <span v-else class="cantidad-cero">0</span>
                            </vs-td>

                            <vs-td>
                                <div v-if="getDetallesProformaPorDescuento(libro.pro_codigo).length > 0">
                                    <div v-for="(detalle, idx) in getDetallesProformaPorDescuento(libro.pro_codigo)" :key="idx" class="detalle-row">
                                        <span :class="detalle.descuento > 0 ? 'descuento-badge' : 'descuento-cero'">{{ detalle.descuento }}%</span>
                                    </div>
                                    <div v-if="getDetallesProformaPorDescuento(libro.pro_codigo).length > 1" class="total-row">
                                        <small class="variados-label">Variados</small>
                                    </div>
                                </div>
                                <span v-else class="descuento-cero">0%</span>
                            </vs-td>

                            <vs-td>
                                <div v-if="getDetallesProformaPorDescuento(libro.pro_codigo).length > 0">
                                    <div v-for="(detalle, idx) in getDetallesProformaPorDescuento(libro.pro_codigo)" :key="idx" class="detalle-row">
                                        <span class="monto-detalle">${{ detalle.subtotal }}</span>
                                    </div>
                                    <div v-if="getDetallesProformaPorDescuento(libro.pro_codigo).length > 1" class="total-row">
                                        <span class="monto-total">${{ getDatosProforma(libro.pro_codigo).subtotalTotal }}</span>
                                    </div>
                                </div>
                                <span v-else class="font-semibold text-purple-600">$0.00</span>
                            </vs-td>

                            <vs-td>
                                <div v-if="getDetallesProformaPorDescuento(libro.pro_codigo).length > 0">
                                    <div v-for="(detalle, idx) in getDetallesProformaPorDescuento(libro.pro_codigo)" :key="idx" class="detalle-row">
                                        <span class="monto-detalle monto-success">${{ detalle.total }}</span>
                                    </div>
                                    <div v-if="getDetallesProformaPorDescuento(libro.pro_codigo).length > 1" class="total-row">
                                        <span class="monto-total monto-total-success">${{ getDatosProforma(libro.pro_codigo).totalTotal }}</span>
                                    </div>
                                </div>
                                <span v-else class="font-bold text-success text-lg">$0.00</span>
                            </vs-td>
                            -->
                            <!-- COLUMNAS DE VENTAS -->
                            <vs-td>
                                <div v-if="getDetallesVentaPorDescuento(libro.pro_codigo).length > 0">
                                    <div v-for="(detalle, idx) in getDetallesVentaPorDescuento(libro.pro_codigo)" :key="idx" class="detalle-row">
                                        <span class="cantidad-badge-venta">{{ detalle.cantidad }}</span>
                                        <span v-if="getDetallesVentaPorDescuento(libro.pro_codigo).length > 1 && detalle.descuento > 0" class="descuento-badge-small">{{ detalle.descuento }}%</span>
                                    </div>
                                    <div v-if="getDetallesVentaPorDescuento(libro.pro_codigo).length > 1" class="total-row">
                                        <strong class="cantidad-total-venta">{{ getDatosVenta(libro.pro_codigo).cantidadTotal }}</strong>
                                    </div>
                                </div>
                                <span v-else class="cantidad-cero">0</span>
                            </vs-td>

                            <vs-td>
                                <div v-if="getDetallesVentaPorDescuento(libro.pro_codigo).length > 0">
                                    <div v-for="(detalle, idx) in getDetallesVentaPorDescuento(libro.pro_codigo)" :key="idx" class="detalle-row">
                                        <span :class="detalle.descuento > 0 ? 'descuento-badge' : 'descuento-cero'">{{ detalle.descuento }}%</span>
                                    </div>
                                    <div v-if="getDetallesVentaPorDescuento(libro.pro_codigo).length > 1" class="total-row">
                                        <small class="variados-label">Variados</small>
                                    </div>
                                </div>
                                <span v-else class="descuento-cero">0%</span>
                            </vs-td>

                            <vs-td>
                                <div v-if="getDetallesVentaPorDescuento(libro.pro_codigo).length > 0">
                                    <div v-for="(detalle, idx) in getDetallesVentaPorDescuento(libro.pro_codigo)" :key="idx" class="detalle-row">
                                        <span class="monto-detalle monto-venta">${{ detalle.subtotal }}</span>
                                    </div>
                                    <div v-if="getDetallesVentaPorDescuento(libro.pro_codigo).length > 1" class="total-row">
                                        <span class="monto-total monto-total-venta">${{ getDatosVenta(libro.pro_codigo).subtotalTotal }}</span>
                                    </div>
                                </div>
                                <span v-else class="font-semibold text-orange-600">$0.00</span>
                            </vs-td>

                            <vs-td>
                                <div v-if="getDetallesVentaPorDescuento(libro.pro_codigo).length > 0">
                                    <div v-for="(detalle, idx) in getDetallesVentaPorDescuento(libro.pro_codigo)" :key="idx" class="detalle-row">
                                        <span class="monto-detalle monto-success-venta">${{ detalle.total }}</span>
                                    </div>
                                    <div v-if="getDetallesVentaPorDescuento(libro.pro_codigo).length > 1" class="total-row">
                                        <span class="monto-total monto-total-success-venta">${{ getDatosVenta(libro.pro_codigo).totalTotal }}</span>
                                    </div>
                                </div>
                                <span v-else class="font-bold text-danger text-lg">$0.00</span>
                            </vs-td>
                            <!-- COLUMNA PENDIENTE - Cantidad -->
                            <vs-td>
                                <vs-chip
                                    :color="calcularPendienteCantidad(libro) > 0 ? 'warning' : 'success'"
                                    class="text-center font-bold"
                                >
                                    {{ calcularPendienteCantidad(libro) }}
                                </vs-chip>
                            </vs-td>
                            <!-- COLUMNA PENDIENTE - Valor -->
                            <vs-td>
                                <span
                                    :class="calcularPendienteValor(libro) > 0 ? 'font-bold text-orange-600 text-lg' : 'font-bold text-green-600 text-lg'"
                                >
                                    ${{ calcularPendienteValor(libro) }}
                                </span>
                            </vs-td>
                        </vs-tr>
                    </template>

                    <!-- FILA DE TOTALES POR COLUMNA -->
                    <template slot="footer">
                        <div class="totales-fila-container">
                            <table class="totales-tabla">
                                <tr class="totales-row">
                                    <td class="totales-cell totales-label-cell" colspan="2">
                                        <strong>TOTALES</strong>
                                    </td>
                                    <!-- Total Contrato Cantidad -->
                                    <td class="totales-cell">
                                        <vs-chip color="dark">{{ totalesColumnas.contratoCantidad }}</vs-chip>
                                    </td>
                                    <!-- Total Contrato Precio (vacío) -->
                                    <td class="totales-cell">—</td>
                                    <!-- Total Contrato Subtotal -->
                                    <td class="totales-cell">
                                        <span class="font-semibold text-blue-600">${{ totalesColumnas.contratoSubtotal }}</span>
                                    </td>
                                    <!-- Total Contrato Descuento (vacío) -->
                                    <td class="totales-cell">—</td>
                                    <!-- Total Contrato Total -->
                                    <td class="totales-cell">
                                        <span class="font-bold text-primary text-lg">${{ totalesColumnas.contratoTotal }}</span>
                                    </td>
                                    <!-- Total Venta Cantidad -->
                                    <td class="totales-cell">
                                        <span class="cantidad-total-venta">{{ totalesColumnas.ventaCantidad }}</span>
                                    </td>
                                    <!-- Total Venta Descuento (vacío) -->
                                    <td class="totales-cell">—</td>
                                    <!-- Total Venta Subtotal -->
                                    <td class="totales-cell">
                                        <span class="font-semibold" style="color: #d97706">${{ totalesColumnas.ventaSubtotal }}</span>
                                    </td>
                                    <!-- Total Venta Total -->
                                    <td class="totales-cell">
                                        <span class="font-bold" style="color: #dc2626; font-size: 16px">${{ totalesColumnas.ventaTotal }}</span>
                                    </td>
                                    <!-- Total Pendiente Cantidad -->
                                    <td class="totales-cell">
                                        <vs-chip :color="totalesColumnas.pendienteCantidad > 0 ? 'warning' : 'success'">{{ totalesColumnas.pendienteCantidad }}</vs-chip>
                                    </td>
                                    <!-- Total Pendiente Valor -->
                                    <td class="totales-cell">
                                        <span :class="totalesColumnas.pendienteValorNum > 0 ? 'font-bold text-orange-600 text-lg' : 'font-bold text-green-600 text-lg'">${{ totalesColumnas.pendienteValor }}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </template>
                </vs-table>

                        <!-- Sin libros -->
                        <div v-else-if="!loadingLibros" class="bg-orange-50 p-4 rounded text-center">
                            <i class="fas fa-book text-2xl text-orange-400 mb-2"></i>
                            <p class="text-orange-600">No se encontraron libros para este pedido</p>
                        </div>
                    </div>
                </vs-tab>

                <!-- TAB 3: Ventas -->
                <vs-tab label="Ventas" icon="shopping_cart">
                    <div class="pt-4">
                        <!-- Componente de Lista de Ventas -->
                        <ListaVentas
                            ref="listaVentas"
                            :contrato="pedidoSeleccionado.contrato_generado"
                            :key="'ventas-' + pedidoSeleccionado.contrato_generado"
                            :librosPedido="librosPedido"
                            :periodo-select="periodoSelect"
                            :pedido-original="pedidoSeleccionado"
                            @venta-anulada="handleVentaAnulada"
                        />
                    </div>
                </vs-tab>

                <!-- TAB Libros hijos docentes/obsequios -->
                <vs-tab label="Libros Docentes/Obsequios" icon="book">
                    <div class="pt-4">
                        <ListadoPedidosObsequios
                            v-if="pedidoSeleccionado"
                            ref="listadoObsequios"
                            :contrato="pedidoSeleccionado.contrato_generado"
                            :pedido-original="pedidoSeleccionado"
                            :periodo-select="periodoSelect"
                            @venta-obsequio-generada="handleVentaObsequioGenerada"
                        />
                        <div v-else class="text-center text-gray-500 py-8">
                            <feather-icon icon="PackageIcon" svgClasses="h-16 w-16 opacity-50"/>
                            <p class="mt-2">Seleccione un pedido para ver los obsequios</p>
                        </div>
                    </div>
                </vs-tab>
                <!-- TAB 2: Proformas -->
                <!-- <vs-tab label="Proformas" icon="receipt">
                    Loading de proformas
                    <div v-if="loadingProformas" class="text-center py-12">
                        <div class="loading-spinner mb-4">
                            <div class="spinner"></div>
                        </div>
                        <p class="text-gray-600 text-lg">Cargando proformas...</p>
                    </div>

                    Componente de Lista de Proformas
                    <ListaProformas
                        v-else
                        ref="listaProformas"
                        :librosPedido="librosPedido"
                        :contrato="pedidoSeleccionado.contrato_generado"
                        :key="pedidoSeleccionado.contrato_generado"
                        @editar-proforma="cargarProformaParaEditar"
                        @venta-creada="handleVentaCreada"
                    />
                </vs-tab> -->
                <!-- TAB 4: Stock Perseo -->
                <!-- <vs-tab label="Stock Perseo">
                    <div class="pt-4">
                        <ListadoGeneralPerseo
                            :librosPedido="librosPedido"
                            :idEmpresa="pedidoSeleccionado ? pedidoSeleccionado.id_empresa : 1"
                        />
                    </div>
                </vs-tab> -->
            </vs-tabs>
        </vx-card>

        <!-- Mensaje cuando no hay pedido seleccionado -->
        <vx-card v-else class="mt-4">
            <div class="text-center py-8">
                <i class="fas fa-search text-4xl text-gray-400 mb-4"></i>
                <h3 class="text-gray-600 mb-2">No hay pedido seleccionado</h3>
                <p class="text-gray-500">Utiliza el buscador de arriba para seleccionar un pedido y ver su información de venta</p>
            </div>
        </vx-card>

        <!-- Modal para CREAR Proforma -->
        <!-- <ProformaModal
            :visible.sync="popupProforma"
            :pedidoSeleccionado="pedidoSeleccionado"
            :librosPedido="librosPedido"
            @cerrar="cerrarProforma"
            @generar-proforma="handleGenerarProforma"
        /> -->

        <!-- Modal para CREAR Venta con Perseo -->
        <VentaModalPerseo
            :visible.sync="popupProformaPerseo"
            :pedidoSeleccionado="pedidoSeleccionado"
            :librosPedido="librosPedido"
            :periodo-select="periodoSelect"
            @cerrar="cerrarProformaPerseo"
            @generar-venta="handleGenerarProformaPerseo"
        />

        <!-- Modal para EDITAR Proforma Normal -->
        <!-- <ProformaEditarModal
            :visible.sync="popupProformaEditar"
            :proformaId="proformaEditarId"
            :pedidoSeleccionado="pedidoSeleccionado"
            :librosPedido="librosPedido"
            :cantidadProformasContrato="cantidadProformasContrato"
            @cerrar="cerrarProformaEditar"
            @actualizar-proforma="handleActualizarProforma"
        /> -->

        <!-- Modal para EDITAR Venta PERSEO -->
        <!-- <VentaEditarModalPerseo
            :visible.sync="popupProformaEditarPerseo"
            :ventaId="proformaEditarId"
            :pedidoSeleccionado="pedidoSeleccionado"
            :librosPedido="librosPedido"
            :periodo-select="periodoSelect"
            :cantidadProformasContrato="cantidadProformasContrato"
            @cerrar="cerrarProformaEditarPerseo"
            @venta-actualizada="handleActualizarProforma"
        /> -->

    </div>
    </template>

    <script>
    import * as XLSX from 'xlsx';
    import vSelect from 'vue-select';
    // const ProformaModal = () => import('./proformas/ProformaModal.vue');
    // const ProformaModalPerseo = () => import('./perseo/proforma/ProformaModalPerseo.vue');
    // const ProformaEditarModalPerseo = () => import('./perseo/proforma/ProformaEditarModalPerseo.vue');
    const VentaModalPerseo = () => import('./perseo/ventas/VentaModalPerseo.vue');
    // const VentaEditarModalPerseo = () => import('./perseo/ventas/VentaEditarModalPerseo.vue');
    const ListadoPedidosObsequios = () => import('./perseo/obsequios/ListadoPedidosObsequios.vue');
    // const ProformaEditarModal = () => import('./proformas/ProformaEditarModal.vue');
    // const ListaProformas = () => import('./proformas/ListaProformas.vue');
    const ListaVentas = () => import('./Ventas/ListaVentas.vue');
    const ListadoGeneralPerseo = () => import('./perseo/ListadoGeneralPerseo.vue');

    export default {
        components: {
            vSelect,
            // ProformaModal,
            VentaModalPerseo,
            // VentaEditarModalPerseo,
            ListadoPedidosObsequios,
            // ProformaEditarModal,
            // ListaProformas,
            ListaVentas,
            ListadoGeneralPerseo
        },
        data() {
            return {
                // Variables para el v-select general
                allPedidos: [],
                pedidoSeleccionado: null,
                // Variables para filtros de tipo de venta
                filtroVentaDirecta: false,
                filtroVentaPorLista: false,
                pedidosFiltrados: [],
                // Filtro de pendientes
                filtroPendientes: false,
                // Variables para los libros del pedido
                librosPedido: [],
                loadingLibros: false,
                // Variable para el modal de proforma CREAR
                popupProforma: false,
                // Variable para el modal de proforma PERSEO
                popupProformaPerseo: false,
                // Variable para el modal de proforma EDITAR
                popupProformaEditar: false,
                popupProformaEditarPerseo: false,
                proformaEditarId: null,
                cantidadProformasContrato: 0,
                // Variables para libros proformados - YA NO SE USA
                // librosProformados: [],
                // loadingProformados: false,
                // Variables para libros vendidos
                librosVendidos: [],
                loadingVendidos: false,
                // Variable para tabs
                tabActiva: 0,
                loadingProformas: false,
            }
        },
        created() {
            let me = this;
            me.usuario = JSON.parse(localStorage.getItem("usuario"))
        },
        mounted() {
            let me = this;
            me.getPedidos();
        },
        watch: {
            // Watcher para reinicializar filtros cuando cambie el periodo
            periodoSelect: {
                handler(newVal, oldVal) {
                    if (newVal && newVal !== oldVal) {
                        this.getPedidos();
                    }
                },
                deep: true
            }
        },
        props: {
            periodoSelect: {
                type: Object,
                default: {},
            },
            userAsesor: {
                type: Boolean,
                default: false,
            },
            userRoot: {
                type: Boolean,
                default: false,
            },
            groupFacturador: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            // Lista de libros filtrada (pendientes o todos)
            librosParaTabla() {
                let me = this;
                if (!me.filtroPendientes) {
                    return me.librosPedido;
                }
                // Filtrar solo los que tienen pendiente > 0
                return me.librosPedido.filter(libro => {
                    const cantidadContrato = parseInt(libro.cantidad) || 0;
                    const cantidadVendida = me.getCantidadVendidaTotal(libro.pro_codigo);
                    return cantidadContrato - cantidadVendida > 0;
                });
            },

            // Totales generales para las tarjetas de resumen
            totalesGenerales() {
                let me = this;
                let contratoCantidad = 0;
                let contratoSubtotal = 0;
                let contratoTotal = 0;
                let ventaCantidad = 0;
                let ventaSubtotal = 0;
                let ventaTotal = 0;

                me.librosParaTabla.forEach(libro => {
                    // CONTRATO
                    const cant = parseInt(libro.cantidad) || 0;
                    const precio = parseFloat(libro.precio) || 0;
                    const descuento = parseFloat(libro.descuento) || 0;
                    const sub = precio * cant;
                    const tot = sub - (sub * descuento / 100);
                    contratoCantidad += cant;
                    contratoSubtotal += sub;
                    contratoTotal += tot;

                    // VENTA
                    const datosV = me.getDatosVenta(libro.pro_codigo);
                    ventaCantidad += datosV.cantidadTotal;
                    ventaSubtotal += parseFloat(datosV.subtotalTotal) || 0;
                    ventaTotal += parseFloat(datosV.totalTotal) || 0;
                });

                const pendienteCantidad = contratoCantidad - ventaCantidad;
                const pendienteSubtotal = contratoSubtotal - ventaSubtotal;
                const pendienteTotal = contratoTotal - ventaTotal;

                return {
                    contrato: {
                        cantidad: contratoCantidad,
                        subtotal: contratoSubtotal.toFixed(2),
                        total: contratoTotal.toFixed(2)
                    },
                    venta: {
                        cantidad: ventaCantidad,
                        subtotal: ventaSubtotal.toFixed(2),
                        total: ventaTotal.toFixed(2)
                    },
                    pendiente: {
                        cantidad: pendienteCantidad,
                        subtotal: pendienteSubtotal.toFixed(2),
                        total: pendienteTotal.toFixed(2)
                    }
                };
            },

            // Totales para la fila de totales por columna
            totalesColumnas() {
                let me = this;
                let contratoCantidad = 0;
                let contratoSubtotal = 0;
                let contratoTotal = 0;
                let ventaCantidad = 0;
                let ventaSubtotal = 0;
                let ventaTotal = 0;
                let pendienteCantidad = 0;
                let pendienteValor = 0;

                me.librosParaTabla.forEach(libro => {
                    const cant = parseInt(libro.cantidad) || 0;
                    const precio = parseFloat(libro.precio) || 0;
                    const descuento = parseFloat(libro.descuento) || 0;
                    const sub = precio * cant;
                    const tot = sub - (sub * descuento / 100);
                    contratoCantidad += cant;
                    contratoSubtotal += sub;
                    contratoTotal += tot;

                    const datosV = me.getDatosVenta(libro.pro_codigo);
                    ventaCantidad += datosV.cantidadTotal;
                    ventaSubtotal += parseFloat(datosV.subtotalTotal) || 0;
                    ventaTotal += parseFloat(datosV.totalTotal) || 0;

                    const pCant = cant - datosV.cantidadTotal;
                    const pVal = tot - (parseFloat(datosV.totalTotal) || 0);
                    pendienteCantidad += pCant;
                    pendienteValor += pVal;
                });

                return {
                    contratoCantidad,
                    contratoSubtotal: contratoSubtotal.toFixed(2),
                    contratoTotal: contratoTotal.toFixed(2),
                    ventaCantidad,
                    ventaSubtotal: ventaSubtotal.toFixed(2),
                    ventaTotal: ventaTotal.toFixed(2),
                    pendienteCantidad,
                    pendienteValorNum: pendienteValor,
                    pendienteValor: pendienteValor.toFixed(2)
                };
            }
        },

        methods: {
            getPedidos() {
                let me = this;
                if (me.periodoSelect == null || me.periodoSelect == "" || me.periodoSelect == undefined) {
                    return;
                }

                const ruta = this.$server_url + 'get_pedidos_periodoAgrupado_new/' + me.periodoSelect.idperiodoescolar;
                me.$vs.loading();

                this.$http.get(ruta)
                .then(res => {
                    me.$vs.loading.close();
                    const datos = res.data.filter(p => p.facturacion_vee == 1);

                    // Preparar todos los pedidos para el v-select con texto de búsqueda
                    me.allPedidos = datos.map(pedido => ({
                        ...pedido,
                        nombreCompleto: `${pedido.nombreInstitucion} - ${pedido.id_pedido} - ${pedido.asesor} - ${pedido.contrato_generado || 'Sin contrato'}`
                    }));

                    // Aplicar filtros iniciales
                    me.aplicarFiltros();
                })
                .catch((e) => {
                    me.$vs.loading.close();
                    console.error('Error al cargar pedidos:', e);
                });
            },

            // Nuevo método para aplicar filtros
            aplicarFiltros() {
                let me = this;

                // Si ningún filtro está activo, mostrar todos los pedidos
                if (!me.filtroVentaDirecta && !me.filtroVentaPorLista) {
                    me.pedidosFiltrados = [...me.allPedidos];
                    return;
                }

                // Filtrar según los checkboxes activos
                me.pedidosFiltrados = me.allPedidos.filter(pedido => {
                    const esDirecta = pedido.tipo_venta == 1;
                    const esPorLista = pedido.tipo_venta != 1;

                    return (
                        (me.filtroVentaDirecta && esDirecta) ||
                        (me.filtroVentaPorLista && esPorLista)
                    );
                });

                // Si el pedido seleccionado ya no está en los filtrados, limpiarlo
                if (me.pedidoSeleccionado && !me.pedidosFiltrados.find(p => p.id_pedido === me.pedidoSeleccionado.id_pedido)) {
                    me.limpiarSeleccion();
                }
            },

            // Método para preseleccionar un contrato (llamado desde el componente padre "Ver en Gestión")
            preseleccionarContrato(contrato_generado) {
                let me = this;

                // Función recursiva que espera a que getPedidos() termine de cargar todos los pedidos
                const buscarYSeleccionar = (intentos = 0) => {
                    if (me.allPedidos && me.allPedidos.length > 0) {
                        // Buscar el pedido que corresponda a este contrato
                        const pedido = me.allPedidos.find(p => p.contrato_generado === contrato_generado);
                        if (pedido) {
                            // Asignarlo al v-model del v-select de búsqueda
                            me.pedidoSeleccionado = pedido;
                            // Disparar las consultas internas como si el usuario lo hubiera seleccionado
                            me.seleccionarPedido(pedido);
                        } else {
                            me.$vs.notify({
                                title: 'Contrato no encontrado',
                                text: 'El contrato no existe o no pertenece al período actual seleccionado.',
                                color: 'warning',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            });
                        }
                    } else if (intentos < 30) {
                        // Reintentar hasta 15 segundos (30 * 500ms) esperando a que la API responda
                        setTimeout(() => buscarYSeleccionar(intentos + 1), 500);
                    } else {
                        me.$vs.notify({ text: 'Tiempo de espera agotado al cargar pedidos', color: 'danger' });
                    }
                };

                buscarYSeleccionar();
            },

            ver_pedido(item) {
                let me = this
                this.$store.dispatch('setPedido', item)
                localStorage.setItem("id_periodo_selected", this.id_periodo)
                localStorage.setItem("nombre_periodo_selected", this.nombre_periodo)
                localStorage.setItem("contrato_generado", item.contrato_generado)
                localStorage.setItem("pedido_desde_admin", 'activo')
                localStorage.setMenu = 0
                me.$emit('showPedido', 4)
            },
            // Métodos para el v-select general
            seleccionarPedido(pedido) {
                let me = this;
                me.pedidoSeleccionado = pedido;
                if (pedido) {
                    me.getLibrosPedido(pedido);
                }
            },
            verPedidoSeleccionado() {
                let me = this;
                if (me.pedidoSeleccionado) {
                    me.ver_pedido(me.pedidoSeleccionado);
                }
            },
            limpiarSeleccion() {
                let me = this;
                me.pedidoSeleccionado = null;
                me.librosPedido = [];
                // me.librosProformados = []; // YA NO SE USA
            },

            getLibrosPedido(pedido) {
                let me = this;
                me.loadingLibros = true;
                me.librosPedido = [];

                const contrato = pedido.contrato_generado;
                const periodo = me.periodoSelect.idperiodoescolar;

                const url = `${me.$server_url}get_libros_pedidosAlcancesXContrato?contrato=${contrato}&periodo=${periodo}`;

                me.$http.get(url)
                .then(res => {
                    me.loadingLibros = false;

                    //Consolidar libros duplicados sumando cantidad
                    let datos = res.data;
                    let consolidados = {};

                    datos.forEach(item => {
                        let qty = parseInt(item.cantidad) || 0;

                        if (consolidados[item.pro_codigo]) {
                            let currentQty = parseInt(consolidados[item.pro_codigo].cantidad) || 0;
                            consolidados[item.pro_codigo].cantidad = currentQty + qty;
                        } else {
                            item.cantidad = qty;
                            item.cantidadVendida = 0; // Inicializar en 0, se actualizará con getLibrosVendidos()
                            consolidados[item.pro_codigo] = { ...item };
                        }
                    });

                    me.librosPedido = Object.values(consolidados);
                    // Cargar también los libros vendidos (proformados ya no se usa)
                    // me.getLibrosProformados(contrato, periodo); // YA NO SE USA
                    me.getLibrosVendidos(contrato, periodo);
                })
                .catch((e) => {
                    me.loadingLibros = false;
                    console.error('Error al cargar libros del pedido:', e);
                    me.$vs.notify({
                        text: 'Error al cargar los libros del pedido',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                });
            },

            // Método para obtener los libros proformados - YA NO SE USA
            // getLibrosProformados(contrato, periodo) {
            //     let me = this;
            //     me.loadingProformados = true;
            //
            //     const url = `${me.$server_url}get_libros_proformados_por_contrato?contrato=${contrato}&periodo=${periodo}`;
            //
            //     me.$http.get(url)
            //     .then(res => {
            //         me.loadingProformados = false;
            //         if (res.data.status === 200) {
            //             me.librosProformados = res.data.data;
            //
            //             // ✅ AGREGAR LIBROS EXTRAS al listado general
            //             // Buscar libros que están en proforma pero NO en el contrato (extras)
            //             me.librosProformados.forEach(libroProformado => {
            //                 const existeEnContrato = me.librosPedido.find(lp => lp.pro_codigo === libroProformado.pro_codigo);
            //
            //                 if (!existeEnContrato) {
            //                     // Este libro es un EXTRA (no está en el contrato original)
            //                     console.log(`📦 Libro EXTRA detectado: ${libroProformado.pro_codigo} - ${libroProformado.nombre_libro}`);
            //
            //                     // Agregar al listado general con valores en 0 para las columnas de contrato
            //                     me.librosPedido.push({
            //                         pro_codigo: libroProformado.pro_codigo,
            //                         nombre_libro: libroProformado.nombre_libro,
            //                         cantidad: 0,  // No está en contrato
            //                         precio: libroProformado.precio_unitario,
            //                         descuento: 0,  // No está en contrato
            //                         esLibroExtra: true  // Marcar como extra
            //                     });
            //
            //                     console.log(`✅ Libro EXTRA agregado al listado general: ${libroProformado.pro_codigo}`);
            //                 }
            //             });
            //         } else {
            //             me.librosProformados = [];
            //         }
            //     })
            //     .catch((e) => {
            //         me.loadingProformados = false;
            //         console.error('Error al cargar libros proformados:', e);
            //         me.librosProformados = [];
            //     });
            // },

            // Método para obtener los libros vendidos
            getLibrosVendidos(contrato, periodo) {
                let me = this;
                me.loadingVendidos = true;

                const url = `${me.$server_url}get_libros_vendidos_por_contrato?contrato=${contrato}&periodo=${periodo}`;

                me.$http.get(url)
                .then(res => {
                    me.loadingVendidos = false;
                    if (res.data.status === 200) {
                        me.librosVendidos = res.data.data;

                        // ✅ ACTUALIZAR cantidadVendida en librosPedido según los libros vendidos
                        me.librosPedido.forEach(libroPedido => {
                            const vendidosDelLibro = me.librosVendidos.filter(lv => lv.pro_codigo === libroPedido.pro_codigo);
                            const cantidadVendidaTotal = vendidosDelLibro.reduce((sum, lv) => {
                                return sum + (parseInt(lv.cantidad_vendida) || 0);
                            }, 0);

                            me.$set(libroPedido, 'cantidadVendida', cantidadVendidaTotal);
                        });

                        // ✅ AGREGAR LIBROS EXTRAS al listado general
                        // Buscar libros que están en ventas pero NO en el listado (extras)
                        me.librosVendidos.forEach(libroVendido => {
                            const existeEnListado = me.librosPedido.find(lp => lp.pro_codigo === libroVendido.pro_codigo);

                            if (!existeEnListado) {
                                // Este libro es un EXTRA (no está en el contrato original)
                                console.log(`📦 Libro EXTRA detectado en ventas: ${libroVendido.pro_codigo} - ${libroVendido.nombre_libro}`);

                                // Calcular cantidad vendida de este libro extra
                                const vendidosDelExtra = me.librosVendidos.filter(lv => lv.pro_codigo === libroVendido.pro_codigo);
                                const cantidadVendidaExtra = vendidosDelExtra.reduce((sum, lv) => {
                                    return sum + (parseInt(lv.cantidad_vendida) || 0);
                                }, 0);

                                // Agregar al listado general con valores en 0 para las columnas de contrato
                                me.librosPedido.push({
                                    pro_codigo: libroVendido.pro_codigo,
                                    nombre_libro: libroVendido.nombre_libro,
                                    cantidad: 0,  // No está en contrato
                                    precio: libroVendido.precio_unitario || 0,
                                    descuento: 0,  // No está en contrato
                                    esLibroExtra: true,  // Marcar como extra
                                    cantidadVendida: cantidadVendidaExtra  // Agregar cantidad vendida
                                });

                                console.log(`✅ Libro EXTRA de venta agregado al listado general: ${libroVendido.pro_codigo}`);
                            }
                        });
                    } else {
                        me.librosVendidos = [];
                    }
                })
                .catch((e) => {
                    me.loadingVendidos = false;
                    console.error('Error al cargar libros vendidos:', e);
                    me.librosVendidos = [];
                });
            },

            // Método para obtener detalles de proforma agrupados por descuento - YA NO SE USA
            // getDetallesProformaPorDescuento(pro_codigo) {
            //     let me = this;
            //     const detalles = me.librosProformados.filter(lp => lp.pro_codigo === pro_codigo);
            //
            //     return detalles.map(detalle => ({
            //         cantidad: parseInt(detalle.cantidad_proformada) || 0,
            //         descuento: parseFloat(detalle.descuento_proforma) || 0,
            //         subtotal: parseFloat(detalle.subtotal_proformado || 0).toFixed(2),
            //         total: parseFloat(detalle.total_proformado || 0).toFixed(2)
            //     }));
            // },
            //
            // // Método para obtener los datos de proforma de un libro específico (TOTALES)
            // getDatosProforma(pro_codigo) {
            //     let me = this;
            //     const detalles = me.librosProformados.filter(lp => lp.pro_codigo === pro_codigo);
            //
            //     if (detalles.length > 0) {
            //         // Sumar todas las cantidades, subtotales y totales
            //         const cantidadTotal = detalles.reduce((sum, d) => sum + (parseInt(d.cantidad_proformada) || 0), 0);
            //         const subtotalTotal = detalles.reduce((sum, d) => sum + (parseFloat(d.subtotal_proformado) || 0), 0);
            //         const totalTotal = detalles.reduce((sum, d) => sum + (parseFloat(d.total_proformado) || 0), 0);
            //
            //         // Para descuento, mostrar el primero o "Variados" si hay múltiples
            //         const descuentos = [...new Set(detalles.map(d => parseFloat(d.descuento_proforma)))];
            //         const descuento = descuentos.length === 1 ? descuentos[0] : 0;
            //
            //         return {
            //             cantidadTotal: cantidadTotal,
            //             descuento: descuento,
            //             subtotalTotal: subtotalTotal.toFixed(2),
            //             totalTotal: totalTotal.toFixed(2),
            //             // Mantener compatibilidad con código anterior
            //             cantidad: cantidadTotal,
            //             subtotal: subtotalTotal.toFixed(2),
            //             total: totalTotal.toFixed(2)
            //         };
            //     }
            //
            //     return {
            //         cantidadTotal: 0,
            //         descuento: 0,
            //         subtotalTotal: '0.00',
            //         totalTotal: '0.00',
            //         cantidad: 0,
            //         subtotal: '0.00',
            //         total: '0.00'
            //     };
            // },

            // Método para obtener detalles de venta agrupados por descuento
            getDetallesVentaPorDescuento(pro_codigo) {
                let me = this;
                const detalles = me.librosVendidos.filter(lv => lv.pro_codigo === pro_codigo);

                return detalles.map(detalle => ({
                    cantidad: parseInt(detalle.cantidad_vendida) || 0,
                    descuento: parseFloat(detalle.descuento_venta) || 0,
                    subtotal: parseFloat(detalle.subtotal_vendido || 0).toFixed(2),
                    total: parseFloat(detalle.total_vendido || 0).toFixed(2)
                }));
            },

            // Método para obtener los datos de venta de un libro específico (TOTALES)
            getDatosVenta(pro_codigo) {
                let me = this;
                const detalles = me.librosVendidos.filter(lv => lv.pro_codigo === pro_codigo);

                if (detalles.length > 0) {
                    // Sumar todas las cantidades, subtotales y totales
                    const cantidadTotal = detalles.reduce((sum, d) => sum + (parseInt(d.cantidad_vendida) || 0), 0);
                    const subtotalTotal = detalles.reduce((sum, d) => sum + (parseFloat(d.subtotal_vendido) || 0), 0);
                    const totalTotal = detalles.reduce((sum, d) => sum + (parseFloat(d.total_vendido) || 0), 0);

                    // Para descuento, mostrar el primero o "Variados" si hay múltiples
                    const descuentos = [...new Set(detalles.map(d => parseFloat(d.descuento_venta)))];
                    const descuento = descuentos.length === 1 ? descuentos[0] : 0;

                    return {
                        cantidadTotal: cantidadTotal,
                        descuento: descuento,
                        subtotalTotal: subtotalTotal.toFixed(2),
                        totalTotal: totalTotal.toFixed(2),
                        // Mantener compatibilidad con código anterior
                        cantidad: cantidadTotal,
                        subtotal: subtotalTotal.toFixed(2),
                        total: totalTotal.toFixed(2)
                    };
                }

                return {
                    cantidadTotal: 0,
                    descuento: 0,
                    subtotalTotal: '0.00',
                    totalTotal: '0.00',
                    cantidad: 0,
                    subtotal: '0.00',
                    total: '0.00'
                };
            },

            // Método para calcular el subtotal de un libro (precio * cantidad)
            calcularSubtotalLibro(libro) {
                const precio = parseFloat(libro.precio) || 0;
                const cantidad = parseInt(libro.cantidad) || 0;

                const subtotal = precio * cantidad;
                return subtotal.toFixed(2);
            },

            // Método para calcular el total de un libro (subtotal - descuento)
            calcularTotalLibro(libro) {
                const subtotal = parseFloat(this.calcularSubtotalLibro(libro));
                const descuento = parseFloat(libro.descuento) || 0;

                const montoDescuento = subtotal * (descuento / 100);
                const total = subtotal - montoDescuento;

                return total.toFixed(2);
            },

            // Método para obtener la cantidad vendida total de un libro
            getCantidadVendidaTotal(pro_codigo) {
                let me = this;
                const detalles = me.librosVendidos.filter(lv => lv.pro_codigo === pro_codigo);
                return detalles.reduce((sum, d) => sum + (parseInt(d.cantidad_vendida) || 0), 0);
            },

            // Método para calcular la cantidad pendiente de un libro
            calcularPendienteCantidad(libro) {
                const cantidadContrato = parseInt(libro.cantidad) || 0;
                const cantidadVendida = this.getCantidadVendidaTotal(libro.pro_codigo);
                return cantidadContrato - cantidadVendida;
            },

            // Método para calcular el valor pendiente de un libro
            calcularPendienteValor(libro) {
                const totalContrato = parseFloat(this.calcularTotalLibro(libro)) || 0;
                const datosVenta = this.getDatosVenta(libro.pro_codigo);
                const totalVendido = parseFloat(datosVenta.totalTotal) || 0;
                const pendiente = totalContrato - totalVendido;
                return pendiente.toFixed(2);
            },

            // Método para calcular el total general del pedido
            calcularTotalPedido() {
                let me = this;
                return me.librosPedido.reduce((total, libro) => {
                    return total + parseFloat(me.calcularTotalLibro(libro));
                }, 0).toFixed(2);
            },

            // Métodos para la proforma
            abrirProforma() {
                console.log('Abriendo modal de proforma');
                let me = this;
                if (!me.pedidoSeleccionado) {
                    me.$vs.notify({
                        text: 'Primero debe seleccionar un pedido',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }

                if (!me.librosPedido || me.librosPedido.length === 0) {
                    me.$vs.notify({
                        text: 'No hay libros en el pedido seleccionado',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }

                // ✅ VALIDAR QUE NO HAYA PROFORMAS PENDIENTES
                if (me.$refs.listaProformas && me.$refs.listaProformas.proformas) {
                    const proformasPendientes = me.$refs.listaProformas.proformas.filter(p => p.prof_estado === 1);

                    if (proformasPendientes.length > 0) {
                        me.$vs.notify({
                            title: '⛔ No se puede crear proforma',
                            text: `Existe ${proformasPendientes.length} proforma(s) <b>PENDIENTE</b>. Debe aprobar, anular o convertir a venta antes de crear una nueva proforma.`,
                            color: 'danger',
                            position: 'top-center',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle',
                            time: 8000
                        });
                        return;
                    }
                }

                console.log(me.popupProforma,'proforma');
                me.popupProforma = true;
                console.log(me.popupProforma, 'proforma');

            },

            abrirVentasPerseo(){
                console.log('Abriendo modal de ventas Perseo');
                let me = this;
                if (!me.pedidoSeleccionado) {
                    me.$vs.notify({
                        text: 'Primero debe seleccionar un pedido',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }

                if (!me.librosPedido || me.librosPedido.length === 0) {
                    me.$vs.notify({
                        text: 'No hay libros en el pedido seleccionado',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }

                // ✅ VALIDAR QUE NO HAYA PROFORMAS PENDIENTES
                if (me.$refs.listaProformas && me.$refs.listaProformas.proformas) {
                    const proformasPendientes = me.$refs.listaProformas.proformas.filter(p => p.prof_estado === 1);

                    if (proformasPendientes.length > 0) {
                        me.$vs.notify({
                            title: '⛔ No se puede crear proforma',
                            text: `Existe ${proformasPendientes.length} proforma(s) <b>PENDIENTE</b>. Debe aprobar, anular o convertir a venta antes de crear una nueva proforma.`,
                            color: 'danger',
                            position: 'top-center',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle',
                            time: 8000
                        });
                        return;
                    }
                }

                console.log('Abriendo modal Perseo');
                me.popupProformaPerseo = true;
            },

            cargarProformaParaEditar(datos) {
                let me = this;

                // Detectar si recibimos objeto con id y tipo, o solo el ID (retrocompatibilidad)
                const proformaId = typeof datos === 'object' ? datos.id : datos;
                const esPerseo = typeof datos === 'object' ? datos.esPerseo : false;

                console.log('═══════════════════════════════════════════════════════');
                console.log('📝 ABRIENDO MODAL DE EDICIÓN DE PROFORMA');
                console.log('═══════════════════════════════════════════════════════');
                console.log('Proforma ID recibido:', proformaId);
                console.log('Es Perseo:', esPerseo);
                console.log('Tipo de ID:', typeof proformaId);
                console.log('═══════════════════════════════════════════════════════');
                console.log('Proforma ID recibido:', proformaId);
                console.log('Tipo de ID:', typeof proformaId);

                // VALIDAR que tengamos un ID válido
                if (!proformaId || proformaId === null || proformaId === undefined) {
                    me.$vs.notify({
                        text: 'Error: No se proporcionó un ID de proforma válido',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    console.error('❌ ID de proforma inválido:', proformaId);
                    return;
                }

                // VALIDAR que tengamos el pedido seleccionado
                if (!me.pedidoSeleccionado) {
                    me.$vs.notify({
                        text: 'Error: No hay pedido seleccionado para editar la proforma',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    console.error('❌ No hay pedido seleccionado');
                    return;
                }

                // VALIDAR que tengamos libros del pedido cargados
                if (!me.librosPedido || me.librosPedido.length === 0) {
                    me.$vs.notify({
                        text: 'Error: No hay libros cargados del pedido',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    console.error('❌ No hay libros del pedido');
                    return;
                }

                console.log('✅ Pedido seleccionado:', me.pedidoSeleccionado.id_pedido);
                console.log('✅ Contrato:', me.pedidoSeleccionado.contrato_generado);
                console.log('✅ Libros disponibles:', me.librosPedido.length);

                // Obtener cantidad de proformas del contrato desde el componente hijo
                if (me.$refs.listaProformas && me.$refs.listaProformas.proformas) {
                    me.cantidadProformasContrato = me.$refs.listaProformas.proformas.length;
                    console.log('✅ Cantidad de proformas en el contrato:', me.cantidadProformasContrato);
                } else {
                    me.cantidadProformasContrato = 1; // Por defecto si no se puede obtener
                }

                // Guardar ID de proforma a editar
                me.proformaEditarId = proformaId;

                // Abrir el modal correcto según el tipo de proforma
                if (esPerseo) {
                    me.popupProformaEditarPerseo = true;
                    console.log('✅ Modal de EDICIÓN PERSEO abierto');
                    console.log('   → Componente: ProformaEditarModalPerseo.vue');
                } else {
                    me.popupProformaEditar = true;
                    console.log('✅ Modal de EDICIÓN NORMAL abierto');
                    console.log('   → Componente: ProformaEditarModal.vue');
                }

                console.log('   → Proforma ID:', proformaId);
                console.log('═══════════════════════════════════════════════════════');
            },

            cerrarProformaEditar() {
                this.popupProformaEditar = false;
                this.proformaEditarId = null;
            },

            cerrarProformaEditarPerseo() {
                this.popupProformaEditarPerseo = false;
                this.proformaEditarId = null;
            },

            handleActualizarProforma(datosProforma) {
                console.log('Datos de proforma actualizada:', datosProforma);
                let me = this;

                // ✅ RECARGAR TODAS LAS 3 APIS para actualizar el listado general
                if (me.pedidoSeleccionado && me.pedidoSeleccionado.contrato_generado) {
                    const contrato = me.pedidoSeleccionado.contrato_generado;
                    const periodo = me.periodoSelect.idperiodoescolar;

                    console.log('🔄 Recargando datos del listado general...');

                    // 1. Recargar libros de CONTRATO (valores base sin extras)
                    me.getLibrosPedido(me.pedidoSeleccionado);

                    // 2. Recargar libros VENDIDOS (proformados ya no se usa)
                    // me.getLibrosProformados(contrato, periodo); // YA NO SE USA
                    me.getLibrosVendidos(contrato, periodo);

                    console.log('✅ Listado general actualizado con valores reales de las APIs');
                }

                // Recargar la lista de proformas
                if (me.$refs.listaProformas) {
                    me.$refs.listaProformas.getProformas();
                    console.log('✅ Lista de proformas actualizada');
                }

                me.$vs.notify({
                    text: 'Proforma actualizada exitosamente',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check'
                });

                // Cerrar el modal después de actualizar
                me.cerrarProformaEditar();
            },

            cerrarProforma() {
                this.popupProforma = false;
            },

            cerrarProformaPerseo() {
                this.popupProformaPerseo = false;
            },

            handleGenerarProforma(datosProforma) {
                console.log('Datos de proforma recibidos:', datosProforma);
                let me = this;

                // ✅ RECARGAR TODAS LAS 3 APIS para actualizar el listado general
                if (me.pedidoSeleccionado && me.pedidoSeleccionado.contrato_generado) {
                    const contrato = me.pedidoSeleccionado.contrato_generado;
                    const periodo = me.periodoSelect.idperiodoescolar;

                    console.log('🔄 Recargando datos del listado general...');

                    // 1. Recargar libros de CONTRATO (valores base sin extras)
                    me.getLibrosPedido(me.pedidoSeleccionado);

                    // 2. Recargar libros VENDIDOS (proformados ya no se usa)
                    // me.getLibrosProformados(contrato, periodo); // YA NO SE USA
                    me.getLibrosVendidos(contrato, periodo);

                    console.log('✅ Listado general actualizado con valores reales de las APIs');
                }

                // Recargar la lista de proformas
                if (me.$refs.listaProformas) {
                    me.$refs.listaProformas.getProformas();
                    console.log('✅ Lista de proformas actualizada después de crear');
                }

                // Nota: La notificación se muestra en el componente ProformaModal

                // Cerrar el modal después de generar
                me.cerrarProforma();
            },

            handleGenerarProformaPerseo(datosProforma) {
                console.log('Datos de proforma Perseo recibidos:', datosProforma);
                let me = this;

                // ✅ RECARGAR TODAS LAS 3 APIS para actualizar el listado general
                if (me.pedidoSeleccionado && me.pedidoSeleccionado.contrato_generado) {
                    const contrato = me.pedidoSeleccionado.contrato_generado;
                    const periodo = me.periodoSelect.idperiodoescolar;

                    console.log('🔄 Recargando datos del listado general (Perseo)...');

                    // 1. Recargar libros de CONTRATO (valores base sin extras)
                    me.getLibrosPedido(me.pedidoSeleccionado);

                    // 2. Recargar libros VENDIDOS (proformados ya no se usa)
                    // me.getLibrosProformados(contrato, periodo); // YA NO SE USA
                    me.getLibrosVendidos(contrato, periodo);

                    console.log('✅ Listado general actualizado con valores reales de las APIs (Perseo)');
                }

                // Recargar la lista de ventas
                if (me.$refs.listaVentas) {
                    me.$refs.listaVentas.getVentas();
                    console.log('✅ Lista de ventas actualizada después de crear (Perseo)');
                }

                // Nota: El modal se cierra automáticamente con el evento @cerrar
            },

            // Método que se ejecuta cuando se crea una venta desde una proforma
            handleVentaCreada() {
                console.log('═══════════════════════════════════════════════════════');
                console.log('✅ VENTA CREADA - Actualizando listado general');
                console.log('═══════════════════════════════════════════════════════');

                let me = this;

                // ✅ RECARGAR TODAS LAS 3 APIS para actualizar el listado general
                if (me.pedidoSeleccionado && me.pedidoSeleccionado.contrato_generado) {
                    const contrato = me.pedidoSeleccionado.contrato_generado;
                    const periodo = me.periodoSelect.idperiodoescolar;

                    console.log('🔄 Recargando datos del listado general...');

                    // 1. Recargar libros de CONTRATO (valores base sin extras)
                    me.getLibrosPedido(me.pedidoSeleccionado);

                    // 2. Recargar libros VENDIDOS (proformados ya no se usa)
                    // me.getLibrosProformados(contrato, periodo); // YA NO SE USA
                    me.getLibrosVendidos(contrato, periodo);

                    console.log('✅ Listado general actualizado con valores reales de las APIs');
                }

                // Recargar la lista de ventas
                if (me.$refs.listaVentas) {
                    me.$refs.listaVentas.getVentas();
                    console.log('✅ Lista de ventas actualizada');
                }
            },

            // Método que se ejecuta cuando se anula una venta
            handleVentaAnulada() {
                console.log('═══════════════════════════════════════════════════════');
                console.log('✅ VENTA ANULADA - Actualizando listado general');
                console.log('═══════════════════════════════════════════════════════');
                let me = this;

                if (me.pedidoSeleccionado && me.pedidoSeleccionado.contrato_generado) {
                    const contrato = me.pedidoSeleccionado.contrato_generado;
                    const periodo = me.periodoSelect.idperiodoescolar;

                    console.log('🔄 Recargando datos después de anular...');

                    me.getLibrosPedido(me.pedidoSeleccionado);
                    me.getLibrosVendidos(contrato, periodo);

                    console.log('✅ Listado general actualizado después de anular');
                }

                if (me.$refs.listaVentas) {
                    me.$refs.listaVentas.getVentas();
                    console.log('✅ Lista de ventas actualizada después de anular');
                }
            },

            // Método que se ejecuta cuando se genera una venta de obsequios
            handleVentaObsequioGenerada(datosVenta) {
                console.log('═══════════════════════════════════════════════════════');
                console.log('✅ VENTA DE OBSEQUIO GENERADA - Actualizando listado');
                console.log('═══════════════════════════════════════════════════════');
                console.log('Datos de venta de obsequio:', datosVenta);

                let me = this;

                // Recargar libros del pedido si está seleccionado
                if (me.pedidoSeleccionado && me.pedidoSeleccionado.contrato_generado) {
                    const contrato = me.pedidoSeleccionado.contrato_generado;
                    const periodo = me.periodoSelect.idperiodoescolar;

                    console.log('🔄 Recargando datos del listado general (Obsequios)...');

                    // 1. Recargar libros de CONTRATO
                    me.getLibrosPedido(me.pedidoSeleccionado);

                    // 2. Recargar libros VENDIDOS
                    me.getLibrosVendidos(contrato, periodo);

                    console.log('✅ Listado general actualizado después de generar venta de obsequios');
                }

                // Recargar la lista de ventas
                if (me.$refs.listaVentas) {
                    me.$refs.listaVentas.getVentas();
                    console.log('✅ Lista de ventas actualizada (Obsequios)');
                }

                // Recargar la lista de pedidos obsequios
                if (me.$refs.listadoObsequios) {
                    me.$refs.listadoObsequios.obtenerPedidosObsequios();
                    console.log('✅ Lista de obsequios actualizada');
                }
            },

            // Método para recargar todos los datos de la tabla manualmente
            recargarDatosTabla() {
                let me = this;

                if (!me.pedidoSeleccionado) {
                    me.$vs.notify({
                        text: 'No hay pedido seleccionado',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }

                const contrato = me.pedidoSeleccionado.contrato_generado;
                const periodo = me.periodoSelect.idperiodoescolar;

                me.$vs.notify({
                    text: 'Actualizando datos...',
                    color: 'primary',
                    iconPack: 'feather',
                    icon: 'icon-refresh-cw'
                });

                // Recargar libros del pedido (esto a su vez recarga ventas)
                me.getLibrosPedido(me.pedidoSeleccionado);

                // Recargar lista de ventas si existe
                if (me.$refs.listaVentas) {
                    me.$refs.listaVentas.getVentas();
                }

                me.$vs.notify({
                    text: 'Datos actualizados correctamente',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    time: 3000
                });
            },

            // ═══════════════════════════════════════════════════════
            // EXPORTAR A EXCEL
            // ═══════════════════════════════════════════════════════
            exportarExcel() {
                let me = this;
                if (!me.pedidoSeleccionado || me.librosParaTabla.length === 0) {
                    me.$vs.notify({
                        text: 'No hay datos para exportar',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                }

                const institucion = me.pedidoSeleccionado.nombreInstitucion || 'Sin Institución';
                const contrato = me.pedidoSeleccionado.contrato_generado || 'Sin Contrato';
                const temporada = me.pedidoSeleccionado.periodo || 'Sin Temporada';

                // ─── Función auxiliar para crear cabecera común ───
                const crearCabecera = () => {
                    return [
                        ['INSTITUCIÓN:', institucion],
                        ['CONTRATO:', contrato],
                        ['TEMPORADA:', temporada],
                        [] // fila vacía de separación
                    ];
                };

                // ════════════════════════════════════════════
                // HOJA 1: CONTRATO
                // ════════════════════════════════════════════
                const dataContrato = crearCabecera();
                dataContrato.push(['Código', 'Libro', 'Cantidad', 'Precio Unit.', 'Subtotal', 'Descuento %', 'Total']);

                me.librosParaTabla.forEach(libro => {
                    const cantidad = parseInt(libro.cantidad) || 0;
                    const precio = parseFloat(libro.precio) || 0;
                    const subtotal = parseFloat(me.calcularSubtotalLibro(libro)) || 0;
                    const descuento = parseFloat(libro.descuento) || 0;
                    const total = parseFloat(me.calcularTotalLibro(libro)) || 0;

                    dataContrato.push([
                        libro.pro_codigo,
                        libro.nombre_libro,
                        cantidad,
                        precio,
                        subtotal,
                        descuento,
                        total
                    ]);
                });

                // Fila de totales Contrato
                dataContrato.push([]);
                dataContrato.push([
                    '', 'TOTALES',
                    me.totalesColumnas.contratoCantidad,
                    '',
                    parseFloat(me.totalesColumnas.contratoSubtotal) || 0,
                    '',
                    parseFloat(me.totalesColumnas.contratoTotal) || 0
                ]);

                // ════════════════════════════════════════════
                // HOJA 2: VENTAS
                // ════════════════════════════════════════════
                const dataVentas = crearCabecera();
                dataVentas.push(['Código', 'Libro', 'Cantidad Vendida', 'Descuento %', 'Subtotal', 'Total']);

                me.librosParaTabla.forEach(libro => {
                    const datosV = me.getDatosVenta(libro.pro_codigo);
                    dataVentas.push([
                        libro.pro_codigo,
                        libro.nombre_libro,
                        datosV.cantidadTotal,
                        datosV.descuento,
                        parseFloat(datosV.subtotalTotal) || 0,
                        parseFloat(datosV.totalTotal) || 0
                    ]);
                });

                // Fila de totales Ventas
                dataVentas.push([]);
                dataVentas.push([
                    '', 'TOTALES',
                    me.totalesColumnas.ventaCantidad,
                    '',
                    parseFloat(me.totalesColumnas.ventaSubtotal) || 0,
                    parseFloat(me.totalesColumnas.ventaTotal) || 0
                ]);

                // ════════════════════════════════════════════
                // HOJA 3: TODO (Contrato + Ventas + Pendientes)
                // ════════════════════════════════════════════
                const dataTodo = crearCabecera();
                dataTodo.push([
                    'Código', 'Libro',
                    'Cant. Contrato', 'Precio Unit.', 'Subtotal Contrato', 'Desc. Contrato %', 'Total Contrato',
                    'Cant. Vendida', 'Desc. Venta %', 'Subtotal Venta', 'Total Venta',
                    'Cant. Pendiente', 'Valor Pendiente'
                ]);

                me.librosParaTabla.forEach(libro => {
                    const cantidad = parseInt(libro.cantidad) || 0;
                    const precio = parseFloat(libro.precio) || 0;
                    const subtotalC = parseFloat(me.calcularSubtotalLibro(libro)) || 0;
                    const descuentoC = parseFloat(libro.descuento) || 0;
                    const totalC = parseFloat(me.calcularTotalLibro(libro)) || 0;
                    const datosV = me.getDatosVenta(libro.pro_codigo);
                    const pendCant = me.calcularPendienteCantidad(libro);
                    const pendVal = parseFloat(me.calcularPendienteValor(libro)) || 0;

                    dataTodo.push([
                        libro.pro_codigo,
                        libro.nombre_libro,
                        cantidad,
                        precio,
                        subtotalC,
                        descuentoC,
                        totalC,
                        datosV.cantidadTotal,
                        datosV.descuento,
                        parseFloat(datosV.subtotalTotal) || 0,
                        parseFloat(datosV.totalTotal) || 0,
                        pendCant,
                        pendVal
                    ]);
                });

                // Fila de totales Todo
                dataTodo.push([]);
                dataTodo.push([
                    '', 'TOTALES',
                    me.totalesColumnas.contratoCantidad,
                    '',
                    parseFloat(me.totalesColumnas.contratoSubtotal) || 0,
                    '',
                    parseFloat(me.totalesColumnas.contratoTotal) || 0,
                    me.totalesColumnas.ventaCantidad,
                    '',
                    parseFloat(me.totalesColumnas.ventaSubtotal) || 0,
                    parseFloat(me.totalesColumnas.ventaTotal) || 0,
                    me.totalesColumnas.pendienteCantidad,
                    parseFloat(me.totalesColumnas.pendienteValor) || 0
                ]);

                // ─── Crear hojas de Excel ───
                const wsContrato = XLSX.utils.aoa_to_sheet(dataContrato);
                const wsVentas = XLSX.utils.aoa_to_sheet(dataVentas);
                const wsTodo = XLSX.utils.aoa_to_sheet(dataTodo);

                // ─── Ajustar anchos de columna ───
                const colWidthsContrato = [
                    { wch: 14 }, { wch: 40 }, { wch: 12 }, { wch: 14 },
                    { wch: 14 }, { wch: 14 }, { wch: 14 }
                ];
                const colWidthsVentas = [
                    { wch: 14 }, { wch: 40 }, { wch: 18 }, { wch: 14 },
                    { wch: 14 }, { wch: 14 }
                ];
                const colWidthsTodo = [
                    { wch: 14 }, { wch: 40 }, { wch: 16 }, { wch: 14 },
                    { wch: 18 }, { wch: 18 }, { wch: 16 },
                    { wch: 16 }, { wch: 16 }, { wch: 16 }, { wch: 14 },
                    { wch: 16 }, { wch: 16 }
                ];
                wsContrato['!cols'] = colWidthsContrato;
                wsVentas['!cols'] = colWidthsVentas;
                wsTodo['!cols'] = colWidthsTodo;

                // ─── Crear workbook y agregar hojas ───
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, wsContrato, 'Contrato');
                XLSX.utils.book_append_sheet(wb, wsVentas, 'Ventas');
                XLSX.utils.book_append_sheet(wb, wsTodo, 'Todo');

                // ─── Generar nombre del archivo ───
                const nombreLimpio = institucion.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ ]/g, '').trim().substring(0, 50);
                const nombreArchivo = `${nombreLimpio} - ${temporada}.xlsx`;

                // ─── Descargar ───
                XLSX.writeFile(wb, nombreArchivo);

                me.$vs.notify({
                    text: 'Excel exportado exitosamente',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check'
                });
            },
        }
    }
    </script>

    <style>
    .fixed-column {
        position: sticky;
        left: 0;
        background-color: white;
    }

    .fixed-column2 {
        position: sticky;
        top: 0;
        background-color: white;
    }

    .popup-footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 20px;
        /* Espacio interno alrededor de los botones */
        background-color: #f0f0f0;
        /* Color de fondo del footer */
        box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
        /* Sombra en la parte inferior */
    }

    /* Estilos para el header agrupado de CONTRATO */
    .header-contrato {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .contrato-label {
        background-color: #f8f9fa;
        color: #495057;
        font-weight: bold;
        font-size: 11px;
        padding: 2px 8px;
        border-radius: 3px;
        margin-bottom: 5%;
        border: 1px solid #dee2e6;
        width: 100%;
        text-align: center;
    }

    /* Estilos para el header agrupado de PROFORMA */
    .header-proforma {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .proforma-label {
        background-color: #e7f3ff;
        color: #0066cc;
        font-weight: bold;
        font-size: 11px;
        padding: 2px 8px;
        border-radius: 3px;
        margin-bottom: 5%;
        border: 1px solid #99ccff;
        width: 100%;
        text-align: center;
    }

    /* Estilos para el header agrupado de VENTAS */
    .header-venta {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .venta-label {
        background-color: #fff4e6;
        color: #d97706;
        font-weight: bold;
        font-size: 11px;
        padding: 2px 8px;
        border-radius: 3px;
        margin-bottom: 5%;
        border: 1px solid #fbbf24;
        width: 100%;
        text-align: center;
    }

    .vs-table thead .vs-table--th {
        padding: 4px 4px !important;
        text-align: center !important;
        font-size: 11px !important;
    }

    .vs-table .vs-table--td {
        padding: 2px 4px !important;
        font-size: 12px !important;
    }

    /* Estilos para detalles de proforma con múltiples descuentos */
    .detalle-row {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 6px 0;
    }

    /* Solo mostrar borde cuando hay múltiples filas */
    .detalle-row:not(:last-child) {
        border-bottom: 1px dashed #e2e8f0;
    }

    .total-row {
        margin-top: 8px;
        padding-top: 8px;
        border-top: 2px solid #4a5568;
        text-align: center;
        background-color: #f7fafc;
    }

    .descuento-badge {
        background-color: #fef3c7;
        color: #92400e;
        font-size: 11px;
        font-weight: bold;
        padding: 3px 8px;
        border-radius: 4px;
        display: inline-block;
    }

    .descuento-badge-small {
        background-color: #fed7aa;
        color: #9a3412;
        font-size: 9px;
        font-weight: 600;
        padding: 2px 5px;
        border-radius: 3px;
        display: inline-block;
        margin-left: 4px;
    }

    .cantidad-badge {
        background-color: #d1fae5;
        color: #065f46;
        font-size: 12px;
        font-weight: 600;
        padding: 3px 10px;
        border-radius: 4px;
        display: inline-block;
    }

    .cantidad-total {
        background-color: #dbeafe;
        color: #1e40af;
        font-size: 13px;
        font-weight: 700;
        padding: 4px 12px;
        border-radius: 4px;
        display: inline-block;
    }

    .cantidad-cero,
    .descuento-cero {
        color: #9ca3af;
        font-size: 12px;
        font-weight: 500;
    }

    .variados-label {
        color: #64748b;
        font-size: 11px;
        font-weight: 600;
        font-style: italic;
    }

    .monto-detalle {
        font-size: 13px;
        font-weight: 600;
        color: #7c3aed;
    }

    .monto-detalle.monto-success {
        color: #059669;
    }

    .monto-total {
        font-size: 15px;
        font-weight: 700;
        color: #5b21b6;
    }

    .monto-total.monto-total-success {
        color: #047857;
        font-size: 16px;
    }

    /* Estilos específicos para VENTAS */
    .cantidad-badge-venta {
        background-color: #ffedd5;
        color: #9a3412;
        font-size: 12px;
        font-weight: 600;
        padding: 3px 10px;
        border-radius: 4px;
        display: inline-block;
    }

    .cantidad-total-venta {
        background-color: #fed7aa;
        color: #9a3412;
        font-size: 13px;
        font-weight: 700;
        padding: 4px 12px;
        border-radius: 4px;
        display: inline-block;
    }

    .monto-detalle.monto-venta {
        color: #d97706;
    }

    .monto-detalle.monto-success-venta {
        color: #dc2626;
    }

    .monto-total.monto-total-venta {
        color: #ea580c;
    }

    .monto-total.monto-total-success-venta {
        color: #dc2626;
        font-size: 16px;
    }

    .vs-td > div {
        min-height: 24px;
    }

    /* Spinner personalizado */
    .loading-spinner {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .spinner {
        width: 60px;
        height: 60px;
        border: 6px solid #f3f3f3;
        border-top: 6px solid #007bff;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    /* Z-index para popup de lista de proformas */
    .popup-lista-proformas {
        z-index: 51005 !important;
    }

    /* Badge para libros extras */
    .libro-extra-badge {
        background-color: #fff4e6;
        color: #ea580c;
        font-size: 9px;
        font-weight: 700;
        padding: 3px 8px;
        border-radius: 4px;
        display: inline-block;
        border: 1px solid #fb923c;
        animation: pulse-extra 2s ease-in-out infinite;
        white-space: nowrap;
    }

    .libro-extra-badge i {
        font-size: 8px;
        margin-right: 2px;
    }

    @keyframes pulse-extra {
        0%, 100% {
            opacity: 1;
            transform: scale(1);
        }
        50% {
            opacity: 0.8;
            transform: scale(0.98);
        }
    }

    /* Utilidades de flex para alinear items */
    .flex {
        display: flex;
    }

    .items-center {
        align-items: center;
    }

    .justify-center {
        justify-content: center;
    }

    .gap-2 {
        gap: 0.5rem;
    }

    /* ===== HEADER PENDIENTE ===== */
    .header-pendiente {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .pendiente-label {
        background-color: #fef3c7;
        color: #92400e;
        font-weight: bold;
        font-size: 11px;
        padding: 2px 8px;
        border-radius: 3px;
        margin-bottom: 5%;
        border: 1px solid #f59e0b;
        width: 100%;
        text-align: center;
    }

    /* ===== BARRA DE TOTALES COMPACTA ===== */
    .totales-barra {
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        border-radius: 6px;
        padding: 6px 12px;
    }

    .totales-barra-inner {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
    }

    .tb-seccion {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .tb-tag {
        font-size: 10px;
        font-weight: 700;
        padding: 2px 6px;
        border-radius: 3px;
        letter-spacing: 0.3px;
        white-space: nowrap;
    }

    .tb-tag-contrato {
        background: #f1f3f5;
        color: #495057;
        border: 1px solid #ced4da;
    }

    .tb-tag-venta {
        background: #fff4e6;
        color: #d97706;
        border: 1px solid #fbbf24;
    }

    .tb-tag-pendiente {
        background: #fef3c7;
        color: #92400e;
        border: 1px solid #f59e0b;
    }

    .tb-dato {
        font-size: 11px;
        color: #64748b;
        white-space: nowrap;
    }

    .tb-dato b {
        color: #334155;
        font-weight: 700;
    }

    .tb-dato-total b {
        color: #1e293b;
        font-size: 12px;
    }

    .tb-divisor {
        width: 1px;
        height: 20px;
        background: #cbd5e1;
        margin: 0 4px;
    }

    /* ===== FILA DE TOTALES EN LA TABLA ===== */
    .totales-fila-container {
        background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
        padding: 12px 8px;
        border-top: 3px solid #475569;
    }

    .totales-tabla {
        width: 100%;
        border-collapse: collapse;
    }

    .totales-row .totales-cell {
        padding: 8px 6px;
        text-align: center;
        vertical-align: middle;
    }

    .totales-label-cell {
        text-align: left !important;
        font-size: 15px;
        color: #1e293b;
        letter-spacing: 0.5px;
    }
    </style>
